import styled, { css } from 'styled-components';

import { getFontStyle } from '~components/Text/helper';

export const cssModalContent = css`
  top: 50%;
  transform: translate3d(-50%, -50%, 0);
`;

export const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-content: stretch;
  width: 100%;
  min-width: 375px;
  height: 628px;
  padding: 19px;
`;

export const Header = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 40px;
`;

export const TitleGroup = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 15px;
`;

export const ModalTitle = styled.h2`
  color: ${({ theme }) => theme.colors.gray900};
  ${getFontStyle('bold120_B2')}
`;

export const ButtonClose = styled.button`
  background: none;
  border-width: 0;
`;
